import { COOKIES, getCookie } from '../../utils/cookie';
import MavenMessages from '@mavenmachines/maven-messages';
import { DriverInfo } from '../profile/types';

export const setupMessages = async (driverInfo: DriverInfo) => {
  const AUTH_TOKEN = getCookie(COOKIES.AUTH_SERVICE_TOKEN);

  await MavenMessages.init({
    companyId: driverInfo.companyId,
    employeeId: driverInfo.employeeId,
    sessionToken: AUTH_TOKEN,
    firebaseConfig: window.MESSAGES,
    apiUrl: window.API_GATEWAY_URL,
    sendMessageNotifications: false,
  });
};
